import { render } from "./UpressAdvert.vue?vue&type=template&id=b317f83c"
import script from "./UpressAdvert.vue?vue&type=script&lang=js"
export * from "./UpressAdvert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__